export enum ActionState {
  NEW = 'NEW',
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
  DELETE = 'DELETE',
  REFRESH = 'REFRESH',
  CLOSE = 'CLOSE',
  UPDATE = 'UPDATE',
  CONFIRM = 'CONFIRM',
  DELETE_NO_REF = 'DELETE_NO_REF',
  LOGIN = 'LOGIN',
  UPLOAD = 'UPLOAD',
}
